const regex = {
  EMAIL: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  NUMERIC: /^[0-9\s]+$/,
  ALPHA_NUMERIC: /^[A-Za-z0-9\s]+$/,
  LEAST_ONE_ALPHANUMERIC: /^(?=.*[a-z\d]).+/,
  NUMERIC_AND_DOT: /^[0-9.\s]+$/,
  PHONE_NUMBER_LENGTH_9_TO_15: /^\+?\d{9,15}$/,
  ALPHANUMERICS_DASH_AND_UNDERSCORE: /^[A-Za-z0-9-_\s]+$/,
  ALPHANUMERICS_DASH_UNDERSCORE_DOTS_SPACE: /^[A-Za-z0-9-_.\s]+$/,
  ALPHANUMERICS_DASH_UNDERSCORE_DOTS: /^[A-Za-z0-9-_.]+$/,
  ALPHANUMERIC_QUESTION_EQUAL_DOTS: /^[A-Za-z0-9?=.\s]+$/,
  PASSWORD: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}/,
  VALID_URL: /(https?:\/\/[^\s]+)/g,
  VALID_URL_V2: /^(https?:\/\/)?(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)$/
}

export default regex
